"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.changeSystemTemplateChannelStatus = changeSystemTemplateChannelStatus;
exports.changeSystemTemplateStatus = changeSystemTemplateStatus;
exports.createSystemTemplate = createSystemTemplate;
exports.deleteSystemTemplate = deleteSystemTemplate;
exports.getAdminList = getAdminList;
exports.getAlertLevels = getAlertLevels;
exports.getAvailableVariables = getAvailableVariables;
exports.getSystemTemplateDetail = getSystemTemplateDetail;
exports.getSystemTemplateList = getSystemTemplateList;
exports.updateSystemTemplate = updateSystemTemplate;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 系统消息模板相关接口
 */

// 列表
function getSystemTemplateList() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _request.default)({
    url: '/admin/system/message/template/list',
    method: 'GET',
    params: params
  });
}

// 详情
function getSystemTemplateDetail(id) {
  return (0, _request.default)({
    url: "/admin/system/message/template/".concat(id),
    method: 'GET'
  });
}

// 创建
function createSystemTemplate() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _request.default)({
    url: '/admin/system/message/template/create',
    method: 'POST',
    data: data
  });
}

// 更新
function updateSystemTemplate() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _request.default)({
    url: '/admin/system/message/template/update',
    method: 'POST',
    data: data
  });
}

// 删除
function deleteSystemTemplate(id) {
  return (0, _request.default)({
    url: "/admin/system/message/template/delete/".concat(id),
    method: 'POST'
  });
}

// 修改总开关状态
function changeSystemTemplateStatus(id, status) {
  return (0, _request.default)({
    url: "/admin/system/message/template/status/".concat(id),
    method: 'POST',
    params: {
      status: status
    }
  });
}

// 修改单个渠道开关状态
function changeSystemTemplateChannelStatus(id, channelCode, enabled) {
  return (0, _request.default)({
    url: "/admin/system/message/template/channel/status/".concat(id),
    method: 'POST',
    params: {
      channelCode: channelCode,
      enabled: enabled
    }
  });
}

// 获取模板可用变量列表
function getAvailableVariables() {
  return (0, _request.default)({
    url: '/admin/system/message/template/variables',
    method: 'GET'
  });
}

// 获取系统管理员列表（用于通知配置）
function getAdminList() {
  return (0, _request.default)({
    url: '/admin/system/message/template/admin-list',
    method: 'GET'
  });
}

// 获取通知级别枚举列表
function getAlertLevels() {
  return (0, _request.default)({
    url: '/admin/system/message/template/alert-levels',
    method: 'GET'
  });
}